import React, { useState, useEffect, useCallback } from 'react';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import { Grid, GridItem } from '../../../components/Grid';
import {
  FormContainer,
  Form,
  Fieldset,
  Legend,
  Label,
  TextInput,
  MessageBox,
  Button,
  ResetButton,
  NumberInput,
  Textarea,
} from '../../../components/FormElements';
import API from '../../../api';
import { API_RESPONSE_TYPES } from '../../../constants';

const AppMetaData = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [appName, setAppName] = useState('');
  const [appLogo, setAppLogo] = useState('');
  const [appFavicon, setAppFavicon] = useState('');
  const [homeBanner, setHomeBanner] = useState('');
  const [appPhoneNumber, setAppPhoneNumber] = useState('');
  const [appEmailAddress, setAppEmailAddress] = useState('');
  const [firmName, setFirmName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [firmAddress, setFirmAddress] = useState('');
  const [invoicePrefix, setInvoicePrefix] = useState('');
  const [hsnCode, setHsnCode] = useState('');
  const [invoiceDescription, setInvoiceDescription] = useState('');
  const [appBackgroundColor, setAppBackgroundColor] = useState('');
  const [appPrimaryColor, setAppPrimaryColor] = useState('');
  const [appSecondaryColor, setAppSecondaryColor] = useState('');
  const [appTertiaryColor, setAppTertiaryColor] = useState('');
  const [appTableHeaderColor, setAppTableHeaderColor] = useState('');
  const [masterDistributorsCommission, setMasterDistributorsCommission] =
    useState('');
  const [distributorsCommission, setDistributorsCommission] = useState('');
  const [retailersCommission, setRetailersCommission] = useState('');
  const [apiUsersCommission, setApiUsersCommission] = useState('');
  const [upiMinimumAmount, setUpiMinimumAmount] = useState(0);
  const [privacyPolicy, setPrivacyPolicy] = useState('');
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [aboutUs, setAboutUs] = useState('');
  const [originalFormData, setOriginalFormData] = useState({});
  const [appAuthLogoBackgroundColor, setAppAuthLogoBackgroundColor] =
    useState('');
  const [appAuthPrimaryBackgroundColor, setAppAuthPrimaryBackgroundColor] =
    useState('');
  const [appAuthTextColor, setAppAuthTextColor] = useState('');
  const [appAuthPrimaryButtonColor, setAppAuthPrimaryButtonColor] =
    useState('');
  const [appAuthPrimaryButtonTextColor, setAppAuthPrimaryButtonTextColor] =
    useState('');
  const [appAuthSecondaryButtonColor, setAppAuthSecondaryButtonColor] =
    useState('');
  const [appAuthSecondaryButtonTextColor, setAppAuthSecondaryButtonTextColor] =
    useState('');
  const [appAuthOTPBackgroundColor, setAppAuthOTPBackgroundColor] =
    useState('');
  const [appMprimaryColor, setAppMprimaryColor] = useState('');
  const [appMsecondaryColor, setAppMsecondaryColor] = useState('');
  const [appMtertiaryColor, setAppMtertiaryColor] = useState('');
  const [appTextColor, setAppTextColor] = useState('');
  const [appIconColor, setAppIconColor] = useState('');
  const [appIconBackgroundColor, setAppIconBackgroundColor] = useState('');
  const [appButtonBackgroundColor, setAppButtonBackgroundColor] = useState('');
  const [appButtonTextColor, setAppButtonTextColor] = useState('');
  const [landingPrimaryColor, setLandingPrimaryColor] = useState('');
  const [landingSecondaryColor, setLandingSecondaryColor] = useState('');
  const [landingTertiaryColor, setLandingTertiaryColor] = useState('');
  const [pendingStatusCheckInterval, setPendingStatusCheckInterval] = useState('');
  const [apiCallBackProcessingTime, setApiCallBackProcessingTime] = useState('');
  const [maximumApiHits, setMaximumApiHits] = useState('');
  const [complaintAllowedDays, setcomplaintAllowedDays] = useState('');
  const [duplicateWalletBalanceCheckInterval, setDuplicateWalletBalanceCheckInterval] = useState('');
  const [defaultRetailerMinimumBalance, setDefaultRetailerMinimumBalance] = useState('');
  const [defaultDistributorMinimumBalance, setDefaultDistributorMinimumBalance] = useState('');
  const [defaultMasterMinimumBalance, setDefaultMasterMinimumBalance] = useState('');
  const [defaultapiMinimumBalance, setDefaultapiMinimumBalance] = useState('');


  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus('');
    setResponseMessage('');
  };

  const resetForm = () => {
    const {
      appName,
      appLogo,
      appFavicon,
      homeBanner,
      appPhoneNumber,
      appEmailAddress,
      appBackgroundColor,
      appPrimaryColor,
      appSecondaryColor,
      appTertiaryColor,
      appTableHeaderColor,
      firmName,
      gstNumber,
      firmAddress,
      invoicePrefix,
      hsnCode,
      invoiceDescription,
      masterDistributorsCommission,
      distributorsCommission,
      retailersCommission,
      apiUsersCommission,
      upiMinimumAmount,
      privacyPolicy,
      termsAndConditions,
      aboutUs,
      appAuthLogoBackgroundColor,
      appAuthPrimaryBackgroundColor,
      appAuthTextColor,
      appAuthPrimaryButtonColor,
      appAuthPrimaryButtonTextColor,
      appAuthSecondaryButtonColor,
      appAuthSecondaryButtonTextColor,
      appAuthOTPBackgroundColor,
      appMprimaryColor,
      appMsecondaryColor,
      appMtertiaryColor,
      appTextColor,
      appIconColor,
      appIconBackgroundColor,
      appButtonBackgroundColor,
      appButtonTextColor,
      landingPrimaryColor,
      landingSecondaryColor,
      landingTertiaryColor,
      pendingStatusCheckInterval,
      apiCallBackProcessingTime,
      maximumApiHits,
      complaintAllowedDays,
      duplicateWalletBalanceCheckInterval,
      defaultDistributorMinimumBalance,
      defaultMasterMinimumBalance,
      defaultapiMinimumBalance,
      defaultRetailerMinimumBalance,
    } = originalFormData;
    setAppName(appName);
    setAppLogo(appLogo);
    setAppFavicon(appFavicon);
    setHomeBanner(homeBanner);
    setAppPhoneNumber(appPhoneNumber);
    setAppEmailAddress(appEmailAddress);
    setAppBackgroundColor(appBackgroundColor);
    setAppPrimaryColor(appPrimaryColor);
    setAppSecondaryColor(appSecondaryColor);
    setAppTertiaryColor(appTertiaryColor);
    setAppTableHeaderColor(appTableHeaderColor);
    setFirmName(firmName);
    setGstNumber(gstNumber);
    setFirmAddress(firmAddress);
    setInvoicePrefix(invoicePrefix);
    setHsnCode(hsnCode);
    setInvoiceDescription(invoiceDescription);
    setMasterDistributorsCommission(masterDistributorsCommission);
    setDistributorsCommission(distributorsCommission);
    setRetailersCommission(retailersCommission);
    setApiUsersCommission(apiUsersCommission);
    setUpiMinimumAmount(upiMinimumAmount);
    setPrivacyPolicy(privacyPolicy);
    setTermsAndConditions(termsAndConditions);
    setAboutUs(aboutUs);
    setAppAuthLogoBackgroundColor(appAuthLogoBackgroundColor);
    setAppAuthPrimaryBackgroundColor(appAuthPrimaryBackgroundColor);
    setAppAuthTextColor(appAuthTextColor);
    setAppAuthPrimaryButtonColor(appAuthPrimaryButtonColor);
    setAppAuthPrimaryButtonTextColor(appAuthPrimaryButtonTextColor);
    setAppAuthSecondaryButtonColor(appAuthSecondaryButtonColor);
    setAppAuthSecondaryButtonTextColor(appAuthSecondaryButtonTextColor);
    setAppAuthOTPBackgroundColor(appAuthOTPBackgroundColor);
    setAppMprimaryColor(appMprimaryColor);
    setAppMsecondaryColor(appMsecondaryColor);
    setAppMtertiaryColor(appMtertiaryColor);
    setAppTextColor(appTextColor);
    setAppIconColor(appIconColor);
    setAppIconBackgroundColor(appIconBackgroundColor);
    setAppButtonBackgroundColor(appButtonBackgroundColor);
    setAppButtonTextColor(appButtonTextColor);
    setLandingPrimaryColor(landingPrimaryColor);
    setLandingSecondaryColor(landingSecondaryColor);
    setLandingTertiaryColor(landingTertiaryColor);
    setPendingStatusCheckInterval(pendingStatusCheckInterval);
    setApiCallBackProcessingTime(apiCallBackProcessingTime);
    setMaximumApiHits(maximumApiHits);
    setcomplaintAllowedDays(complaintAllowedDays);
    setDuplicateWalletBalanceCheckInterval(duplicateWalletBalanceCheckInterval);
    setDefaultDistributorMinimumBalance(defaultDistributorMinimumBalance);
    setDefaultMasterMinimumBalance(defaultMasterMinimumBalance);
    setDefaultapiMinimumBalance(defaultapiMinimumBalance);
    setDefaultRetailerMinimumBalance(defaultRetailerMinimumBalance);
  };

  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(`/configurations/meta-details`)
      .then(({ data }) => {
        const {
          appName,
          appLogo,
          appFavicon,
          homeBanner,
          appPhoneNumber,
          appEmailAddress,
          appBackgroundColor,
          appPrimaryColor,
          appSecondaryColor,
          appTertiaryColor,
          appTableHeaderColor,
          firmName,
          gstNumber,
          firmAddress,
          invoicePrefix,
          hsnCode,
          invoiceDescription,
          masterDistributorsCommission,
          distributorsCommission,
          retailersCommission,
          apiUsersCommission,
          upiMinimumAmount,
          privacyPolicy,
          termsAndConditions,
          aboutUs,
          appAuthLogoBackgroundColor,
          appAuthPrimaryBackgroundColor,
          appAuthTextColor,
          appAuthPrimaryButtonColor,
          appAuthPrimaryButtonTextColor,
          appAuthSecondaryButtonColor,
          appAuthSecondaryButtonTextColor,
          appAuthOTPBackgroundColor,
          appMprimaryColor,
          appMsecondaryColor,
          appMtertiaryColor,
          appTextColor,
          appIconColor,
          appIconBackgroundColor,
          appButtonBackgroundColor,
          appButtonTextColor,
          landingPrimaryColor,
          landingSecondaryColor,
          landingTertiaryColor,
          pendingStatusCheckInterval,
          apiCallBackProcessingTime,
          maximumApiHits,
          complaintAllowedDays,
          duplicateWalletBalanceCheckInterval,
          defaultDistributorMinimumBalance,
          defaultMasterMinimumBalance,
          defaultapiMinimumBalance,
          defaultRetailerMinimumBalance,
        } = data;
        setAppName(appName);
        setAppLogo(appLogo);
        setAppFavicon(appFavicon);
        setHomeBanner(homeBanner);
        setAppPhoneNumber(appPhoneNumber);
        setAppEmailAddress(appEmailAddress);
        setAppBackgroundColor(appBackgroundColor);
        setAppPrimaryColor(appPrimaryColor);
        setAppSecondaryColor(appSecondaryColor);
        setAppTertiaryColor(appTertiaryColor);
        setAppTableHeaderColor(appTableHeaderColor);
        setFirmName(firmName);
        setGstNumber(gstNumber);
        setFirmAddress(firmAddress);
        setInvoicePrefix(invoicePrefix);
        setHsnCode(hsnCode);
        setInvoiceDescription(invoiceDescription);
        setMasterDistributorsCommission(masterDistributorsCommission);
        setDistributorsCommission(distributorsCommission);
        setRetailersCommission(retailersCommission);
        setApiUsersCommission(apiUsersCommission);
        setUpiMinimumAmount(upiMinimumAmount);
        setPrivacyPolicy(privacyPolicy);
        setTermsAndConditions(termsAndConditions);
        setAboutUs(aboutUs);
        setAppAuthLogoBackgroundColor(appAuthLogoBackgroundColor);
        setAppAuthPrimaryBackgroundColor(appAuthPrimaryBackgroundColor);
        setAppAuthTextColor(appAuthTextColor);
        setAppAuthPrimaryButtonColor(appAuthPrimaryButtonColor);
        setAppAuthPrimaryButtonTextColor(appAuthPrimaryButtonTextColor);
        setAppAuthSecondaryButtonColor(appAuthSecondaryButtonColor);
        setAppAuthSecondaryButtonTextColor(appAuthSecondaryButtonTextColor);
        setAppAuthOTPBackgroundColor(appAuthOTPBackgroundColor);
        setAppMprimaryColor(appMprimaryColor);
        setAppMsecondaryColor(appMsecondaryColor);
        setAppMtertiaryColor(appMtertiaryColor);
        setAppTextColor(appTextColor);
        setAppIconColor(appIconColor);
        setAppIconBackgroundColor(appIconBackgroundColor);
        setAppButtonBackgroundColor(appButtonBackgroundColor);
        setAppButtonTextColor(appButtonTextColor);
        setLandingPrimaryColor(landingPrimaryColor);
        setLandingSecondaryColor(landingSecondaryColor);
        setLandingTertiaryColor(landingTertiaryColor);
        setPendingStatusCheckInterval(pendingStatusCheckInterval);
        setApiCallBackProcessingTime(apiCallBackProcessingTime);
        setMaximumApiHits(maximumApiHits);
        setcomplaintAllowedDays(complaintAllowedDays);
        setDuplicateWalletBalanceCheckInterval(duplicateWalletBalanceCheckInterval);
        setDefaultDistributorMinimumBalance(defaultDistributorMinimumBalance);
        setDefaultMasterMinimumBalance(defaultMasterMinimumBalance);
        setDefaultapiMinimumBalance(defaultapiMinimumBalance);
        setDefaultRetailerMinimumBalance(defaultRetailerMinimumBalance);
        setOriginalFormData({
          appName,
          appLogo,
          appFavicon,
          homeBanner,
          appPhoneNumber,
          appEmailAddress,
          appBackgroundColor,
          appPrimaryColor,
          appSecondaryColor,
          appTertiaryColor,
          appTableHeaderColor,
          firmName,
          gstNumber,
          firmAddress,
          invoicePrefix,
          hsnCode,
          invoiceDescription,
          masterDistributorsCommission,
          distributorsCommission,
          retailersCommission,
          apiUsersCommission,
          upiMinimumAmount,
          privacyPolicy,
          termsAndConditions,
          aboutUs,
          appAuthLogoBackgroundColor,
          appAuthPrimaryBackgroundColor,
          appAuthTextColor,
          appAuthPrimaryButtonColor,
          appAuthPrimaryButtonTextColor,
          appAuthSecondaryButtonColor,
          appAuthSecondaryButtonTextColor,
          appAuthOTPBackgroundColor,
          appMprimaryColor,
          appMsecondaryColor,
          appMtertiaryColor,
          appTextColor,
          appIconColor,
          appIconBackgroundColor,
          appButtonBackgroundColor,
          appButtonTextColor,
          landingPrimaryColor,
          landingSecondaryColor,
          landingTertiaryColor,
          pendingStatusCheckInterval,
          apiCallBackProcessingTime,
          maximumApiHits,
          complaintAllowedDays,
          duplicateWalletBalanceCheckInterval,
          defaultDistributorMinimumBalance,
          defaultMasterMinimumBalance,
          defaultapiMinimumBalance,
          defaultRetailerMinimumBalance,
        });
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    const formData = {
      appName,
      appLogo,
      appFavicon,
      homeBanner,
      appPhoneNumber,
      appEmailAddress,
      firmName,
      gstNumber,
      firmAddress,
      invoicePrefix,
      hsnCode,
      invoiceDescription,
      appBackgroundColor,
      appPrimaryColor,
      appSecondaryColor,
      appTertiaryColor,
      appTableHeaderColor,
      masterDistributorsCommission,
      distributorsCommission,
      retailersCommission,
      apiUsersCommission,
      upiMinimumAmount,
      privacyPolicy,
      termsAndConditions,
      aboutUs,
      appAuthLogoBackgroundColor,
      appAuthPrimaryBackgroundColor,
      appAuthTextColor,
      appAuthPrimaryButtonColor,
      appAuthPrimaryButtonTextColor,
      appAuthSecondaryButtonColor,
      appAuthSecondaryButtonTextColor,
      appAuthOTPBackgroundColor,
      appMprimaryColor,
      appMsecondaryColor,
      appMtertiaryColor,
      appTextColor,
      appIconColor,
      appIconBackgroundColor,
      appButtonBackgroundColor,
      appButtonTextColor,
      landingPrimaryColor,
      landingSecondaryColor,
      landingTertiaryColor,
      pendingStatusCheckInterval,
      apiCallBackProcessingTime,
      maximumApiHits,
      complaintAllowedDays,
      duplicateWalletBalanceCheckInterval,
      defaultDistributorMinimumBalance,
      defaultMasterMinimumBalance,
      defaultapiMinimumBalance,
      defaultRetailerMinimumBalance,
    };
    API.put(`/configurations/meta-details`, formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setTimeout(() => {
            resetResponseData();
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    readData();
  }, [readData]);

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Fieldset forLegend>
            <Legend>APP Configuration</Legend>

            <Grid
              columns={
                'calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label required>App Name</Label>
                  <TextInput
                    value={appName}
                    onChange={setAppName}
                    placeholder="Please enter app name"
                    disabled={isLoading === true}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>App Logo Url</Label>
                  <TextInput
                    value={appLogo}
                    onChange={setAppLogo}
                    placeholder="Please enter app logo url"
                    disabled={isLoading === true}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>App Favicon Url</Label>
                  <TextInput
                    value={appFavicon}
                    onChange={setAppFavicon}
                    placeholder="Please enter app favicon url"
                    disabled={isLoading === true}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Fieldset>
              <Label>Home Banner</Label>
              <TextInput
                value={homeBanner}
                onChange={setHomeBanner}
                placeholder="Please enter home banner url"
                disabled={isLoading === true}
              />
            </Fieldset>{' '}
          </Fieldset>
          <Fieldset forLegend>
            <Legend>Flat Commission Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label required>Master Distributors Commission</Label>
                  <NumberInput
                    value={masterDistributorsCommission}
                    onChange={setMasterDistributorsCommission}
                    placeholder="Please enter master distributors commission"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Distributors Commission</Label>
                  <NumberInput
                    value={distributorsCommission}
                    onChange={setDistributorsCommission}
                    placeholder="Please enter distributors commission"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Retailers Commission</Label>
                  <NumberInput
                    value={retailersCommission}
                    onChange={setRetailersCommission}
                    placeholder="Please enter retailers commission"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>API Users Commission</Label>
                  <NumberInput
                    value={apiUsersCommission}
                    onChange={setApiUsersCommission}
                    placeholder="Please enter api users commission"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend>
            <Legend>Mimimum Balance Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label required>MD Balance Lock</Label>
                  <NumberInput
                    value={defaultMasterMinimumBalance}
                    onChange={setDefaultMasterMinimumBalance}
                    placeholder="Please enter MD Balance Lock Amount"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Dist Balance Lock</Label>
                  <NumberInput
                    value={defaultDistributorMinimumBalance}
                    onChange={setDefaultDistributorMinimumBalance}
                    placeholder="Please enter Distributor Balance Lock Amount"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Ret Balance Lock</Label>
                  <NumberInput
                    value={defaultRetailerMinimumBalance}
                    onChange={setDefaultRetailerMinimumBalance}
                    placeholder="Please enter retailers Balance Lock Amount"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>API Balance Lock</Label>
                  <NumberInput
                    value={defaultapiMinimumBalance}
                    onChange={setDefaultapiMinimumBalance}
                    placeholder="Please enter api Balance Lock Amount"
                    maxLength={100}
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend>
            <Legend>Payment Configuration</Legend>
            <Grid
              columns={
                'calc(50% - 10px) calc(50% - 10px)'
              }
            >
              <Fieldset>
                <Label>PG Minimum Load</Label>
                <NumberInput
                  value={upiMinimumAmount}
                  onChange={setUpiMinimumAmount}
                  placeholder="Please enter upi minimum amount"
                  maxLength={100}
                  disabled={isLoading === true}
                  pattern={`[0-9.]*`}
                />
              </Fieldset>
              <Fieldset>
                <Label>Duplicate Amount Interval</Label>
                <NumberInput
                  value={duplicateWalletBalanceCheckInterval}
                  onChange={setDuplicateWalletBalanceCheckInterval}
                  placeholder="Please Enter in Minutes"
                  maxLength={100}
                  disabled={isLoading === true}
                  pattern={`[0-9.]*`}
                />
              </Fieldset>
            </Grid>
          </Fieldset>
          <Fieldset forLegend>
            <Legend>Recharge Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label required>Pending Check Interval</Label>
                  <TextInput
                    value={pendingStatusCheckInterval}
                    onChange={setPendingStatusCheckInterval}
                    placeholder="Please enter Status Check Interval"
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Callback Processing Interval</Label>
                  <TextInput
                    value={apiCallBackProcessingTime}
                    onChange={setApiCallBackProcessingTime}
                    placeholder="Please enter app logo url"
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>API Retry Attempts</Label>
                  <TextInput
                    value={maximumApiHits}
                    onChange={setMaximumApiHits}
                    placeholder="Please enter Maximum API Hits"
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Complaint Acceptance Days</Label>
                  <TextInput
                    value={complaintAllowedDays}
                    onChange={setcomplaintAllowedDays}
                    placeholder="Please enter Complaint Days"
                    disabled={isLoading === true}
                    pattern={`[0-9.]*`}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend>
            <Legend>App ComplianceConfiguration</Legend>
            <Fieldset>
              <Label>Privacy Policy ( Text or HTML Body )</Label>
              <Textarea
                placeholder="Please enter privacy policy"
                value={privacyPolicy}
                onChange={(e) => {
                  setPrivacyPolicy(e.target.value);
                }}
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>Terms & Conditions ( Text or HTML Body )</Label>
              <Textarea
                placeholder="Please enter terms and conditions"
                value={termsAndConditions}
                onChange={(e) => {
                  setTermsAndConditions(e.target.value);
                }}
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>About Us ( Text or HTML Body )</Label>
              <Textarea
                placeholder="Please enter about us"
                value={aboutUs}
                onChange={(e) => {
                  setAboutUs(e.target.value);
                }}
                disabled={isLoading}
              />
            </Fieldset>
          </Fieldset>
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <Button disabled={isLoading === true} type="submit">
              Update
            </Button>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(AppMetaData);
